import { render, staticRenderFns } from "./footerDashMobile.vue?vue&type=template&id=d78e00e8&scoped=true&"
import script from "./footerDashMobile.vue?vue&type=script&lang=js&"
export * from "./footerDashMobile.vue?vue&type=script&lang=js&"
import style0 from "./footerDashMobile.vue?vue&type=style&index=0&id=d78e00e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78e00e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VIcon,VSheet})
